module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "main update_trip_wrp"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "c-pointer"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateTrip()
      }
    }
  }, [_vm._v("Update Transfer Point Trip")])])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_data_paddi"
  }, [_c('div', {
    staticClass: "shedule_date_data"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Schedule Date and Time")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.details.scheduleTime ?
    _vm.details.scheduleTime :
    "--") + "\n            ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Point")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.endLoc ? _vm.details.endLoc.plantName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.details.driverId ? _vm.details.driverId.firstName + " " + _vm.details.driverId.lastName : "--") + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Vehicle")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.vehicleId ? _vm.details.vehicleId.vNumber : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Waste (KG)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalWeight))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Status")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tripStatus))])])]), _vm._v(" "), _c('div', {
    staticClass: "collection_division_details_ssec"
  }, [_c('h3', [_vm._v("Waste Transferred From")]), _vm._v(" "), _c('v-server-table', {
    ref: "tripDetailsTable",
    staticClass: "surveyDetailsTable_paddi",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Date and Time")]), _vm._v(" "), _c('p', [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Date and Time")]), _vm._v(" "), _c('p', [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Point")]), _vm._v(" "), _c('p', [_vm._v("--")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b279c8f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b279c8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/secondaryTrip/secondary.vue
// module id = 2355
// module chunks = 0